import { fromUnixTime } from "date-fns/esm";

import Select from "ds/components/Select";
import SelectItem from "ds/components/Select/Item";
import { PolicyEvaluationRecord } from "types/generated";
import { formatDate } from "utils/date";

import { BADGE_STATES } from "./constants";
import EvaluationRecordStatusBadge from "./EvaluationRecordStatusBadge";
import { EvaluationRecordOutcomeStatus } from "./types";

type PolicyDetailsInputSelectProps = {
  inputs: PolicyEvaluationRecord[];
  handleInputKeyChange: (value: string) => void;
  currentPolicyInputKey: string;
};

const PolicyDetailsInputSelect = ({
  inputs,
  handleInputKeyChange,
  currentPolicyInputKey,
}: PolicyDetailsInputSelectProps) => {
  const policyInputsOptions = inputs.map((value) => ({
    label: formatDate({
      date: fromUnixTime(value.timestamp),
    }),
    value: value.key,
    result: value.outcome,
  }));

  const currentPolicyInput =
    currentPolicyInputKey &&
    policyInputsOptions.find(
      (policyInputsOption) => policyInputsOption.value === currentPolicyInputKey
    );

  const inputKeyValue = currentPolicyInput ? currentPolicyInput.value : "";

  return (
    <Select
      label="Sampled previous inputs"
      items={policyInputsOptions}
      onChange={handleInputKeyChange}
      value={inputKeyValue}
      placeholder={
        policyInputsOptions.length === 0 ? "No previous inputs" : "Input from previous samples"
      }
    >
      {(item) => (
        <SelectItem
          id={item.value}
          label={item.label}
          value={item.value}
          suffix={
            <EvaluationRecordStatusBadge
              status={BADGE_STATES[item.result] || EvaluationRecordOutcomeStatus.Info}
              text={item.result.toLocaleUpperCase()}
            />
          }
        />
      )}
    </Select>
  );
};

export default PolicyDetailsInputSelect;
